(function () {
  if (window.__shopByConcernInitialized) return;
  window.__shopByConcernInitialized = true;

  function closeOverlay(overlay) {
    overlay.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-concern-open]');
    if (opener) {
      var overlay = document.getElementById(opener.dataset.concernOpen);
      if (overlay) {
        overlay.classList.add('active');
        document.body.classList.add('overflow-hidden');
      }
      return;
    }

    var closer = event.target.closest('[data-concern-close]');
    if (closer) {
      closeOverlay(closer.closest('[data-concern-overlay]'));
      return;
    }

    if (event.target.hasAttribute('data-concern-overlay')) {
      closeOverlay(event.target);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-concern-overlay].active').forEach(closeOverlay);
  });
})();
